export const assertIsError = (error: unknown) => {
  if (error instanceof Error) {
    return error as Error;
  } else {
    throw error;
  }
};
